export default __webpack_public_path__ + "static/media/Budget_202324.d6bff0f2.pdf";